<template>
<ItpPage
  :noHeader="b_7315092382398562_noHeader"
  no-primary-button
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="EntityEvents"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    class="h-100"
    v-if="loaded"
  >
    <DIV
      class="row h-100"
    >
      <DIV
        class="col-6 h-100"
      >
        <VueSlickgrid
          name="events"
          :headerTitle="'Events'|pgettext('EntityEvents')"
          :items="ds"
          checkbox-row-selection
          :headerShowColumnSelectorButton="b_7789867021953041_headerShowColumnSelectorButton"
          :headerShowReloadButton="b_7789867021953041_headerShowReloadButton"
          export-to-csv
          :exportToCsvFilename="'payments'|pgettext('ExportFilename')"
          :columns="b_7789867021953041_columns"
          @command:event_name="evh_7789867021953041_commandEventName($event, {})"
        >
        </VueSlickgrid>
      </DIV>
      <DIV
        class="col-6 h-100 overflow-hidden"
      >
        <CodeMirror
          mode="json"
          :options="b_2070266589801014_options"
          v-model="eventData"
          class="h-100 v-100"
        >
        </CodeMirror>
      </DIV>
    </DIV>
  </UcBody>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class EntityEvents extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
  })
  entityId!: string;

  @Watch('entityId')
  onEntity_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("entityId")
  }

  @Prop({
    type: String,
    default: "full-screen",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  selectedEventId!: any;
  eventData!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_entity_events', { parameters: { id: this.entityId } })
  }

  ux!: any;
  b_7315092382398562_noHeader!: any;
  b_7315092382398562_modalBindings!: any;
  b_7789867021953041_headerShowColumnSelectorButton!: any;
  b_7789867021953041_headerShowReloadButton!: any;
  b_7789867021953041_columns!: any;
  b_2070266589801014_options!: any;
  dataMembers = ['selectedEventId', 'eventData', 'ds', 'ux', 'b_7315092382398562_noHeader', 'b_7315092382398562_modalBindings', 'b_7789867021953041_headerShowColumnSelectorButton', 'b_7789867021953041_headerShowReloadButton', 'b_7789867021953041_columns', 'b_2070266589801014_options'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedEventId: null,
        eventData: null,
        ds: null,
        ux: null,
        b_7315092382398562_noHeader: false,
        b_7315092382398562_modalBindings: {
          noHeader: false,
          noPrimaryButton: true,
          size: "full-screen",
        }
        ,
        b_7789867021953041_headerShowColumnSelectorButton: false,
        b_7789867021953041_headerShowReloadButton: false,
        b_7789867021953041_columns: [{
          field: "event_name",
          name: this.$fn.pgettext("EntityEvents", "Event"),
          type: "command",
        }
          ,
        {
          field: "timestamp",
          name: this.$fn.pgettext("EntityEvents", "Timestamp"),
          formatter: {
            name: "datetime",
          }
          ,
        }
          ,
        {
          field: "identity",
          name: this.$fn.pgettext("EntityEvents", "User"),
          formatter: {
            name: "user",
          }
          ,
        }
          ,
        ]
        ,
        b_2070266589801014_options: {
          lineNumbers: true,
          matchBrackets: true,
          continueComments: "Enter",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("EntityEvents/header", "Entity events"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2308_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2308, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_7789867021953041_setData_2312_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_7789867021953041_setData_2312, alias=undefined
    return {
      path: "selectedEventId",
      value: $event.data.data.id,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_7789867021953041_setData_2316_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_7789867021953041_setData_2316, alias=undefined
    return {
      path: "eventData",
      value: JSON.stringify($event.data.response.data, null, 2),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_7789867021953041_request_2314_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_7789867021953041_request_2314, alias=loadEventData
    return {
      operation: "read_entity_event_data",
      data: { id: this.entityId, event_id: this.selectedEventId },
    }
  }

  async evh_7789867021953041_commandEventName(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7789867021953041_commandEventName.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2308: actions.CloseModalAction;
    evh_7315092382398562_close_2307: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_2310: actions.CloseModalAction;
    evh_2248226175642056_close_2309: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_7789867021953041_setData_2312: actions.SetDataAction;
    evh_7789867021953041_commandEventName_2311: actions.EventHandlerImpl;
    act_7789867021953041_setData_2316: actions.SetDataAction;
    evh_7789867021953041_success_2315: actions.EventHandlerImpl;
    act_7789867021953041_request_2314: actions.RequestAction;
    evh_7789867021953041_commandEventName_2313: actions.EventHandlerImpl;
    evh_7789867021953041_commandEventName: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2308 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2308_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2307 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2308,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2307],
      }
    );
    const act_2248226175642056_closeModal_2310 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2309 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_2310,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2309],
      }
    );
    const act_7789867021953041_setData_2312 = new actions.SetDataAction(
      {
        actionArgs: this.act_7789867021953041_setData_2312_getActionArgs,
        events: [],
      }
    );
    const evh_7789867021953041_commandEventName_2311 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_setData_2312,
        event: "command:event_name",
        displayName: "setData",
      }
    );
    const act_7789867021953041_setData_2316 = new actions.SetDataAction(
      {
        actionArgs: this.act_7789867021953041_setData_2316_getActionArgs,
        events: [],
      }
    );
    const evh_7789867021953041_success_2315 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_setData_2316,
        event: "success",
        displayName: "setData",
      }
    );
    const act_7789867021953041_request_2314 = new actions.RequestAction(
      {
        actionArgs: this.act_7789867021953041_request_2314_getActionArgs,
        displayName: "loadEventData",
        events: [evh_7789867021953041_success_2315],
      }
    );
    const evh_7789867021953041_commandEventName_2313 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_request_2314,
        event: "command:event_name",
        displayName: "loadEventData",
      }
    );
    const evh_7789867021953041_commandEventName = new actions.EventHandlerGroup(
      {
        handlers: [evh_7789867021953041_commandEventName_2311, evh_7789867021953041_commandEventName_2313],
      }
    );
    return {
      act_7315092382398562_closeModal_2308,
      evh_7315092382398562_close_2307,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_2310,
      evh_2248226175642056_close_2309,
      evh_2248226175642056_close,
      act_7789867021953041_setData_2312,
      evh_7789867021953041_commandEventName_2311,
      act_7789867021953041_setData_2316,
      evh_7789867021953041_success_2315,
      act_7789867021953041_request_2314,
      evh_7789867021953041_commandEventName_2313,
      evh_7789867021953041_commandEventName,
      loadEventData: act_7789867021953041_request_2314,
    }
  }
}

Vue.component("EntityEvents", EntityEvents);

</script>